import React, { useState, useEffect } from 'react';

import './PregnancyCalendar.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import { pregnancyWeekList, babyWeekList } from '../../helpers/userWeek';

const { ArrowUp, ArrowDown } = icons;

export default function PregnancyCalendar(props) {
  const babyCalendar = props.type === 'baby';

  const [view, setView] = useState(props.view);

  pregnancyWeekList.forEach(
    (item, idx) =>
      (item.imageSrc = `/calendar/pregnancy/${view}/${idx + 1}.webp`)
  );

  babyWeekList.forEach(
    (item, idx) =>
      (item.imageSrc =
        idx < 17
          ? `/calendar/baby/${idx + 1}.webp`
          : `/calendar/baby/month-${idx - 12}.webp`)
  );

  useEffect(() => {
    if (document.body.offsetWidth > 850) setView('desktop');
    else setView('mobile');
  }, []);

  return (
    <section id="pregnancyCalendar">
      {!babyCalendar && (
        <Calendar weeks={pregnancyWeekList} nextLink={props.nextLink} />
      )}

      {view && !props.hideWeekList && (
        <List
          view={view}
          nextLink={props.nextLink}
          babyCalendar={babyCalendar}
          weeks={babyCalendar ? babyWeekList : pregnancyWeekList}
        />
      )}
    </section>
  );
}

function Calendar(props) {
  const [isFolded, toogleView] = useState(true);

  return (
    <div id="pregnancyCalendar_calendar" onClick={() => toogleView(!isFolded)}>
      <div id="pregnancyCalendar_calendar_toggler">
        <p>Selecteer je zwangerschapsweek</p>

        {isFolded ? <ArrowDown /> : <ArrowUp />}
      </div>

      {!isFolded && (
        <ul>
          {props.weeks.map((week, idx) => (
            <li key={idx}>
              {link(
                <span>{week.number}</span>,
                `/week-${idx + 1}`,
                props.nextLink
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function List(props) {
  return (
    <ul id="pregnancyCalendar_list">
      {props.weeks.map((week, idx) => (
        <li key={idx}>
          <img alt={week.link} src={week.imageSrc} />

          <p>{props.babyCalendar ? 'Baby' : 'Zwanger'}</p>

          {link(
            <div>
              {week.number} {week.label.toLowerCase()}
            </div>,
            week.link,
            props.nextLink
          )}
        </li>
      ))}
    </ul>
  );
}
